import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  SearchRequest,
  SearchRequestCriteria,
  TankmixTest,
} from "../../models/searchRequest";
import { ApiService } from "../../services/api.service";

import { PreferencesService } from "../../services/preferences.service";
import { ReferenceDataService } from "../../services/reference-data.service";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { NamedId } from "../../models/NamedId";
import { Subscription, merge, forkJoin } from "rxjs";
import { tap, mergeAll, map } from "rxjs/operators";

import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { SearchHistoryService } from "../../services/search-history.service";
import { ActivatedRoute } from "@angular/router";
import { SearchRequestHistoryItem } from "../../models/searchRequestHistoryItem";
import { KindPage } from "../../enums/kind-page";
import { TemplateClickEventsHaveKeyEventsRule } from "codelyzer";


@Component({
  selector: "app-search",
  templateUrl: "./search.component.html",
})
export class SearchComponent implements OnInit, OnDestroy {
  maxLimit: number = 500;
  faFilePdf: any = faFilePdf;
  previousSearches: SearchRequest[] = [];
  showIntroduction: boolean = true;
  countryChoices: NamedId[] = [];
  yaraProductChoices: NamedId[] = [];
  activeIngredientChoices: NamedId[] = [];
  agrochemicalChoices: NamedId[] = [];
  results: TankmixTest[] = null;
  searchForm: UntypedFormGroup;

  searching: boolean;
  choicesSubscription: Subscription;
  preferencesSub: Subscription;
  countryChosen: boolean = false;
  languageCode: string;
  searchHistoryItem: SearchRequestHistoryItem;
  searchRequestCriteria: SearchRequestCriteria;
  limitedResults: TankmixTest[];

  constructor(
    private api: ApiService,
    private preferencesService: PreferencesService,
    private refData: ReferenceDataService,
    private fb: UntypedFormBuilder,
    private searchHistory: SearchHistoryService,
    private route: ActivatedRoute
  ) {
    this.searchForm = this.fb.group({
      countryCode: [null],
      activeIngredientCode: [null],
      yaraChemicalId: [null],
      agrochemicalCode: [null],
    });


    this.preferencesService.languageCode$.subscribe(
      (code) => {
        (this.languageCode = code)
        //this.performSearch();
      }
    );

    this.searchForm.valueChanges.subscribe((values) => {
      if (values.countryCode != null) {
        this.countryChosen = true;
        this.preferencesService.countryCode = values.countryCode;
      }
      if (values.countryCode != null && values.yaraChemicalId != null) {
        this.api
          .getAgrochemicalsTestedWith(
            values.countryCode,
            values.yaraChemicalId.id
          )
          .subscribe((products) => {
            this.agrochemicalChoices = products;
            //at this point we can replace chemical generic names with yara market specific names
            this.setMarketSpecificNames();
            return
          });

        this.api
          .getActivesTestedWith(values.countryCode, values.yaraChemicalId.id)
          .subscribe((actives) => (this.activeIngredientChoices = actives));
      }
    });
    this.showIntroduction = true;
  }


  get formValues(): any {
    return this.searchForm.value;
  }
  ngOnDestroy(): void {
    this.choicesSubscription.unsubscribe();
    this.preferencesSub.unsubscribe();
  }

  changeCountry() {
    this.refData.setCountry(this.formValues.countryCode).subscribe((x) => {
      this.yaraProductChoices = x;
    });

  
    this.getData();
 
  }

  getData() {
    this.choicesSubscription = forkJoin(
        this.api.getagrochemicals(),
        this.api.getActiveIngredients()
    ).pipe(
      tap(([agrochemicals,activeIngredients]) => {
         this.agrochemicalChoices = agrochemicals;
         this.activeIngredientChoices = activeIngredients;
         this.setMarketSpecificNames();
         
      })
    ).subscribe();
    this.resetSearch();
  }

  ngOnInit() {
    this.preferencesSub = this.preferencesService.countryCode$.subscribe(
      (countryCode) => {
        this.searchForm.patchValue({ 
          countryCode: countryCode, 
        });
        this.changeCountry();
      }
    );



    this.choicesSubscription = forkJoin(
      this.refData.getCountries(),
      //this.refData.getActiveIngredients(),
     // this.refData.getagrochemicals()
    )
      .pipe(
        tap(([countries]) => {
          this.countryChoices = countries;
         // this.activeIngredientChoices = actives;
         // this.agrochemicalChoices = chemicals;

          /// we can't substitute correct names at this point, because we do not know which country the dude is using
          this.setMarketSpecificNames();
        })
      )
      .subscribe();

    // check if page comes from search history component
    let index = this.route.snapshot.params.id;
    if (index != undefined) {
      this.searchHistoryItem = this.searchHistory.getHistoryItem(index);
      if (this.searchHistoryItem == undefined) {
        return;
      }
      this.pathFormWithSearchCriteria();
    } else {
      //try last search results
      var res = this.searchHistory.retrieveSearchResults("foliar");
      if (res != null) {
        this.results = res;
        this.limitedResults = res.slice(0, 50);
        this.searching = false;
      }
    }
  }

  pathFormWithSearchCriteria() {
    var criteria = this.searchHistoryItem.criteria;
    this.searchForm.patchValue(criteria);
    this.performSearch();
  }
  searchAgain() {
    this.results = null;
  }
  resetSearch() {
   
    this.searchForm.patchValue({
   
      activeIngredientCode: null,
     yaraChemicalId: null,
      agrochemicalCode: null,
     });
  }

  toggleIntroduction() {
    this.showIntroduction = !this.showIntroduction;
  }

  performSearch() {

    this.searching = true;
    let val = this.searchForm.value;
    console.log(this.languageCode + val.countryCode);

    this.api
      .search({
        countryCode: val.countryCode,
        activeIngredientCode: val.activeIngredientCode?.id,
        agrochemicalCode: val.agrochemicalCode?.id,
        languageCode: this.languageCode,
        yaraChemicalId: val.yaraChemicalId?.id,
      })
      .subscribe((x: TankmixTest[]) => {
        this.results = x;
        this.searchHistory.storeSearchResults(x, 'foliar');
        this.limitedResults = x.slice(0, 50);
        this.searching = false;

        // store result in local storage
        this.storeSearchCriteria(val, x.length);
      });
  }

  private storeSearchCriteria(criteria: any, numberOfResults: number) {
    this.searchHistory.storeSearchCritera(
      criteria,
      numberOfResults,
      KindPage.FoliarTankmix
    );
  }
  addMoreSearchResults() {
    console.log("Adding search results");

    if (this.results.length > this.limitedResults.length) {
      this.limitedResults = this.limitedResults.concat(
        this.results.slice(
          this.limitedResults.length,
          this.limitedResults.length + 50
        )
      );

      console.log(
        `Now showing ${this.limitedResults.length} of ${this.results.length}`
      );
    }
  }
  convertedAppRate(inp: number) {
    return this.preferencesService.convertApplicationUnits(inp);
  }
  convertedWaterRate(inp: number) {
    return this.preferencesService.convertWaterUnits(inp);
  }
  convertPowderUnits(inp: number) {
    return this.preferencesService.convertPowderUnits(inp);
  }
  setMarketSpecificNames() {
    if (this.agrochemicalChoices==null || this.yaraProductChoices==null) {
    console.log("Not possible to do name substitution")  
      return;
    }

    this.yaraProductChoices.forEach(yaraProduct => {
      var found = this.agrochemicalChoices.find(x => x.id === yaraProduct.id);
      if (found != null) {
        found.name = yaraProduct.name;
      }
    });



  }
}
